import {
  editorModeFromSegment,
  editorRouteSegments,
  editorSegmentForMode,
  isEditorRouteSegment,
  type EditorRouteMode,
} from './editor'

export const mailboxFolderRouteSegments = [
  'inbox',
  'messages',
  'attachments',
  'favs',
  'starred',
  'drafts',
  'trash',
  'deleted',
] as const

export const mailboxEditorRouteSegments = editorRouteSegments
export type MailboxEditorMode = EditorRouteMode

export function mailboxEditorModeFromSegment(segment: string): MailboxEditorMode | undefined {
  return editorModeFromSegment(segment)
}

export function mailboxEditorSegmentForMode(mode: MailboxEditorMode): 'new' | 'edit' {
  return editorSegmentForMode(mode)
}

export function isMailboxEditorSegment(segment: string): boolean {
  return isEditorRouteSegment(segment)
}

const mailboxRequestSegmentSet = new Set<string>([
  '',
  ...mailboxFolderRouteSegments,
  ...mailboxEditorRouteSegments,
])

export function isMailboxRequestSegment(segment: string): boolean {
  return mailboxRequestSegmentSet.has(segment)
}
